export const externalConstants = {
  GET_BRANCH_REQUEST: 'GET_BRANCH_REQUEST',
  GET_BRANCH_SUCCESS: 'GET_BRANCH_SUCCESS',
  GET_BRANCH_FAILURE: 'GET_BRANCH_FAILURE',
}

